import { render, staticRenderFns } from "./WoundMonitor.vue?vue&type=template&id=b0ae6318&"
import script from "./WoundMonitor.vue?vue&type=script&lang=js&"
export * from "./WoundMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports